export interface ReportPrintSettings {
  saleAutoPrint: boolean;
  paymentAutoPrint: boolean;
  paperSize: "Yarım A4" | "Tam A4";
  saleFooterMessage: string;
  paymentFooterMessage: string;
}

const STORAGE_KEY = "evrenciftligi_report_print_settings_v1";
const listeners = new Set<() => void>();

const defaultSettings: ReportPrintSettings = {
  saleAutoPrint: false,
  paymentAutoPrint: false,
  paperSize: "Yarım A4",
  saleFooterMessage:
    "Hayırlı Bayramlar • www.EvrenCiftligi.com ziyaret etmeyi unutmayın.",
  paymentFooterMessage:
    "Ödemeniz için teşekkür ederiz • www.EvrenCiftligi.com",
};

function readStorage(): ReportPrintSettings {
  if (typeof window === "undefined") return defaultSettings;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultSettings;

    const parsed = JSON.parse(raw) as Partial<ReportPrintSettings>;
    return {
      saleAutoPrint:
        typeof parsed.saleAutoPrint === "boolean"
          ? parsed.saleAutoPrint
          : defaultSettings.saleAutoPrint,
      paymentAutoPrint:
        typeof parsed.paymentAutoPrint === "boolean"
          ? parsed.paymentAutoPrint
          : defaultSettings.paymentAutoPrint,
      paperSize:
        parsed.paperSize === "Tam A4" ? "Tam A4" : defaultSettings.paperSize,
      saleFooterMessage:
        typeof parsed.saleFooterMessage === "string"
          ? parsed.saleFooterMessage
          : defaultSettings.saleFooterMessage,
      paymentFooterMessage:
        typeof parsed.paymentFooterMessage === "string"
          ? parsed.paymentFooterMessage
          : defaultSettings.paymentFooterMessage,
    };
  } catch {
    return defaultSettings;
  }
}

function writeStorage(settings: ReportPrintSettings) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}

let currentSettings = readStorage();

function emit() {
  listeners.forEach((listener) => listener());
}

export function getReportPrintSettings() {
  currentSettings = readStorage();
  return currentSettings;
}

export function subscribeReportPrintSettings(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function updateReportPrintSettings(
  updater:
    | Partial<ReportPrintSettings>
    | ((prev: ReportPrintSettings) => ReportPrintSettings)
) {
  const next =
    typeof updater === "function"
      ? updater(getReportPrintSettings())
      : { ...getReportPrintSettings(), ...updater };

  currentSettings = next;
  writeStorage(next);
  emit();
}
